import { AuthEnvironment } from "../backend/interfaces/IAuthenticationProvider";
import { LogError } from "./ErrorTelemetry";
import { LogEventNames } from "../backend/interfaces/ITelemetryLogger";
import { ICON_DEFAULT_BASE_URL, ICON_USSEC_BASE_URL, ICON_USNAT_BASE_URL } from "../AppConstants";

// Pure utility to derive auth environment from AugLoop service URL. No DOM/window usage.
export function getAuthEnvironmentFromAugLoopServiceUrl(augloopServiceUrl: string): AuthEnvironment {
  if(!augloopServiceUrl) {
    LogError(LogEventNames.Warning, "Augloop service URL is null, hence pointing to prod");
    return AuthEnvironment.Prod;
  }

  if (augloopServiceUrl.indexOf('augloop-gcc.office.com') >= 0) {
    return  AuthEnvironment.GCC;
  } else if (augloopServiceUrl.indexOf('augloop.gov.online.office365.us') >= 0) {
    return  AuthEnvironment.GCCHigh;
  } else if (augloopServiceUrl.indexOf('augloop.dod.online.office365.us') >= 0) {
    return  AuthEnvironment.DOD;
  } else if (augloopServiceUrl.indexOf('svc.augloop.eaglex.ic.gov') >= 0) {
    return AuthEnvironment.USNAT;
  } else if (augloopServiceUrl.indexOf('svc.augloop.microsoft.scloud') >= 0) {
    return AuthEnvironment.USSEC;
  } else if (augloopServiceUrl.indexOf('msit.augloop.svc.cloud.microsoft') >= 0) {
    return AuthEnvironment.MSIT;
  } else {          
    return AuthEnvironment.Prod;
  }
}

/**
 * Gets the appropriate icon base URL based on the authentication environment
 * @param authEnvironment The authentication environment
 * @returns The icon base URL for the given environment
 */
export function getIconBaseUrlForEnvironment(authEnvironment: AuthEnvironment): string {
    switch (authEnvironment) {
        case AuthEnvironment.USSEC:
            return ICON_USSEC_BASE_URL;
        case AuthEnvironment.USNAT:
            return ICON_USNAT_BASE_URL;
        default:
            return ICON_DEFAULT_BASE_URL;
    }
}
